import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { AuditRead } from '../../entities/audit.dto';

@Injectable()
export class AuditStore extends AbstractEntityStore<AuditRead> {
    constructor() {
        super(PFWmsEntities.Audit);
    }
}
